function formatPhone(number) {
  var numbers = number.replace(/\D/g, '');
  var char = { 0: '', 3: '-', 6: '-' };
  var i;
  var formated;
  formated = '';
  for (i = 0; i < numbers.length; i++) {
    formated += (char[i] || '') + numbers[i];
  }
  return formated;
}

module.exports = {
  formatter: {
    phone: formatPhone,
  },
};
